<template>
  <div id="natcon-member-payment" class="natcon-luxury-app">
    <!-- Overlay Loader -->
    <v-overlay
      :value="ProgressLoadingFlag"
      z-index="99999"
      class="luxury-overlay"
    >
      <div class="luxury-spinner-wrapper">
        <v-progress-circular
          indeterminate
          size="72"
          width="5"
          color="#ffd700"
        ></v-progress-circular>
        <div class="luxury-spinner-text">Processing Request...</div>
      </div>
    </v-overlay>

    <!-- HERO HEADER SECTION -->
    <div class="luxury-hero-section">
      <!-- Animated Background Layers -->
      <div class="mesh-gradient-bg"></div>
      <div class="aurora-lights"></div>
      <div class="animated-glow-orbs">
        <div class="orb orb-1"></div>
        <div class="orb orb-2"></div>
        <div class="orb orb-3"></div>
      </div>
      <div class="moving-light-rays"></div>
      <div class="glass-reflection-overlay"></div>
      <div class="soft-noise-overlay"></div>

      <!-- Luxury Floating Decorative Elements -->
      <div class="luxury-decorations">
        <div class="floating-element diamond d1"></div>
        <div class="floating-element ring r1"></div>
        <div class="floating-element circle c1"></div>
        <div class="floating-element cube cb1"></div>
        <div class="floating-element golden-particle p1"></div>
        <div class="floating-element golden-particle p2"></div>
        <div class="floating-element sparkle s1">✦</div>
        <div class="floating-element sparkle s2">✦</div>
        <div class="floating-element sparkle s3">★</div>
        <div class="floating-element line l1"></div>
        <div class="floating-element glow-wave w1"></div>
      </div>

      <!-- Hero Content Container -->
      <div class="hero-content-wrapper">
        <!-- Premium Glass Hero Card -->
        <div class="hero-glass-card">
          <!-- Floating Glassy Bubble Animations -->
          <div class="hero-bubbles">
            <div class="bubble bubble-1"></div>
            <div class="bubble bubble-2"></div>
            <div class="bubble bubble-3"></div>
            <div class="bubble bubble-4"></div>
            <div class="bubble bubble-5"></div>
            <div class="bubble bubble-6"></div>
          </div>

          <div class="hero-card-glow-border"></div>
          <div class="hero-card-shine-sweep"></div>

          <div class="hero-badge">
            <span class="badge-icon">👑</span>
            <span class="badge-text">OFFICIAL EVENT REGISTRATION</span>
          </div>

          <h1 class="hero-main-title" v-if="PageTitle">
            {{ PageTitle }}
          </h1>
          <h1 class="hero-main-title" v-else>
            NATCON
            <span class="text-gradient-sky">OFFICIAL EVENT REGISTRATION</span>
          </h1>

          <p class="hero-subtitle">
            {{
              PageDescription ||
              "Experience the grandest annual conference & celebration. Reserve your official event plans today."
            }}
          </p>

          <!-- Information Glass Pills -->
          <div class="hero-pills-row">
            <div class="hero-pill">
              <i class="mdi mdi-calendar pill-icon"></i>
              <span
                >Year:
                <strong>{{ YearName || JciYearCode || "2026" }}</strong></span
              >
            </div>
            <div class="hero-pill">
              <i class="mdi mdi-ticket pill-icon"></i>
              <span
                >Plans: <strong>{{ Plans.length || 0 }} Available</strong></span
              >
            </div>
            <div
              class="hero-pill"
              v-if="
                (selectedMember && selectedMember.LomName) ||
                (Lom && Lom.LomName)
              "
            >
              <i class="mdi mdi-shield-check pill-icon"></i>
              <span
                >{{ selectedMember.LomName || Lom.LomName }}
                <small v-if="selectedMember.ZoneName || Lom.ZoneName"
                  >({{ selectedMember.ZoneName || Lom.ZoneName }})</small
                ></span
              >
            </div>
          </div>

          <!-- Hero Action Buttons -->
          <div class="hero-actions-row">
            <button
              class="glass-btn primary-glass-btn"
              @click.prevent="refreshPageData"
            >
              <i class="mdi mdi-refresh btn-icon"></i>
              <span>Refresh Data</span>
            </button>

            <button
              class="glass-btn secondary-glass-btn"
              @click.prevent="resetForm"
            >
              <i class="mdi mdi-eraser btn-icon"></i>
              <span>Clear Form</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- STATISTICS SECTION -->
    <div class="luxury-stats-bar">
      <div class="stats-container">
        <div class="stat-card">
          <div class="stat-icon-box gold">
            <i class="mdi mdi-trophy"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">
              {{ YearName || JciYearCode || "2026" }}
            </div>
            <div class="stat-label">Event Year</div>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon-box purple">
            <i class="mdi mdi-domain"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value text-truncate" style="max-width: 160px">
              {{
                (selectedMember && selectedMember.LomName) ||
                (Lom && Lom.LomName) ||
                (Member && Member.LomName) ||
                ""
              }}
            </div>
            <div class="stat-label">
              {{
                (selectedMember &&
                  (selectedMember.ZoneName || selectedMember.ZoneCode)) ||
                (Lom && (Lom.ZoneName || Lom.ZoneCode)) ||
                (Member && (Member.ZoneName || Member.ZoneCode)) ||
                ""
              }}
            </div>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon-box blue">
            <i class="mdi mdi-account-group"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">
              {{ (AllParticipants && AllParticipants.length) || Qty || 0 }}
              Participants
            </div>
            <div class="stat-label">Registered Participants</div>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon-box emerald">
            <i class="mdi mdi-check-decagram"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">Official Plan</div>
            <div class="stat-label">NATCON Registration</div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <v-dialog v-model="addNonMemberRecordPrompt" persistent max-width="75%">
        <add-sma-non-member
          pageTitle="Add Participant details"
          pageDescription="Add non member details"
          :showDialog="addNonMemberRecordPrompt"
          @hideDialog="addNewNonMember($event)"
          v-if="addNonMemberRecordPrompt"
        ></add-sma-non-member>
      </v-dialog>

      <!-- Notes Alert -->
      <v-alert
        type="info"
        prominent
        border="left"
        class="notes-alert mb-6"
        v-if="NotesFlag"
        icon="mdi-information-outline"
      >
        <div class="alert-content">
          <h3 class="alert-title">Important Instructions</h3>
          <ol class="alert-list">
            <li>Regular subscription can be paid only once.</li>
            <li>
              After paying regular subscription, choose additional subscription.
            </li>
            <li>
              Late fee is optional but paying late fee is required to get voting
              rights.
            </li>
            <li>
              After completing the payment, kindly select your members for whom
              the payment was made.
            </li>
          </ol>
        </div>
      </v-alert>

      <!-- Required Fields Note -->
      <v-card class="required-note-card mb-6" elevation="0">
        <div class="required-note-content">
          <div class="required-note-icon">
            <v-icon large color="white">mdi-information</v-icon>
          </div>
          <div class="required-note-text">
            <span class="required-note-label">
              <span class="asterisk">*</span> Indicates Required Field
            </span>
          </div>
        </div>
      </v-card>
      <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
        <b-spinner variant="primary" type="grow" label="Loading..."></b-spinner>
      </div>
      <v-container v-if="StartupLoadingFlag">
        <v-row wrap>
          <v-col cols="12" md="4" v-for="n in 6" :key="n">
            <v-skeleton-loader
              v-bind="attrs"
              type="paragraph"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-if="!StartupLoadingFlag">
        <v-form ref="form2" v-model="valid1" lazy-validation>
          <!-- Registration Details Card -->
          <v-card elevation="8" class="form-card mb-6">
            <div class="form-card-header">
              <v-icon large class="header-icon"
                >mdi-clipboard-list-outline</v-icon
              >
              <div class="ml-4">
                <h2 class="form-card-title">Registration Details</h2>
                <p class="form-card-subtitle">
                  Select registration type and member
                </p>
              </div>
            </div>
            <v-divider class="my-0"></v-divider>
            <v-card-text class="pt-6">
              <v-row wrap>
                <v-col cols="12" md="4">
                  <h4 class="field-label">
                    <v-icon small class="mr-2" color="primary"
                      >mdi-account-multiple</v-icon
                    >
                    <span class="text-danger">*</span> Member Type
                  </h4>
                  <v-select
                    v-model="MemberType"
                    :items="MemberTypeOptions"
                    :rules="MemberTypeRules"
                    :reduce="(option) => option.value"
                    required
                    outlined
                    dense
                    rounded
                    class="form-control"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4" v-if="MemberType == 2">
                  <h4 class="field-label">
                    <v-icon small class="mr-2" color="primary"
                      >mdi-account-search</v-icon
                    >
                    <span class="text-danger">*</span> Select Member
                  </h4>
                  <v-autocomplete
                    @change="getSelectedMemberDetails"
                    :reduce="(option) => option.value"
                    :loading="MemberIdOptionsLoading"
                    :items="MemberIdOptions"
                    :rules="MemberIdRules"
                    v-model="MemberId"
                    required
                    outlined
                    dense
                    rounded
                    clearable
                    class="form-control"
                  >
                    <template v-slot:selection="{ item }">
                      <img
                        width="40"
                        height="40"
                        :src="item.photo"
                        class="rounded-circle mr-2"
                      />{{ item.text }}
                    </template>
                    <template v-slot:item="{ item }">
                      <img
                        width="40"
                        height="40"
                        :src="item.photo"
                        class="rounded-circle mr-2"
                      />{{ item.text }}
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Member Details Card -->
          <v-card
            elevation="8"
            class="form-card mb-6"
            v-if="MemberType != '' && MemberId != ''"
          >
            <div class="form-card-header">
              <v-icon large class="header-icon"
                >mdi-account-details-outline</v-icon
              >
              <div class="ml-4">
                <h2 class="form-card-title">{{ RegisterDetailsTxt }}</h2>
                <p class="form-card-subtitle">
                  Verify and update member information
                </p>
              </div>
            </div>
            <v-divider class="my-0"></v-divider>
            <v-card-text class="pt-6">
              <v-row wrap>
                <v-col cols="12" sm="6" md="3">
                  <div class="member-photo-container text-center">
                    <v-img
                      :src="selectedMember.MemberImagePath"
                      :alt="selectedMember.MemberName"
                      lazy-src="/no-image-available.png"
                      max-width="140"
                      max-height="140"
                      class="member-photo mx-auto"
                      v-if="selectedMember.MemberImagePath != ''"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="primary"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <div v-else class="placeholder-photo mx-auto">
                      <v-icon size="64" color="primary">mdi-account</v-icon>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3" md="3">
                  <div class="info-card h-100">
                    <p class="info-label">Member Name</p>
                    <h3 class="info-value">{{ selectedMember.MemberName }}</h3>
                    <div class="mt-4">
                      <p class="info-label">Membership ID</p>
                      <h3 class="info-value">
                        {{ selectedMember.MembershipId }}
                      </h3>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3" md="3">
                  <h4 class="field-label">
                    <v-icon small class="mr-2" color="primary"
                      >mdi-email</v-icon
                    >
                    <span class="text-danger">*</span> Email
                  </h4>
                  <v-text-field
                    v-model="selectedMember.EmailId"
                    :rules="EmailIdRules"
                    placeholder="Enter email address"
                    outlined
                    dense
                    rounded
                    class="form-control"
                    type="email"
                    prepend-inner-icon="mdi-at"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" lg="3" md="3">
                  <h4 class="field-label">
                    <v-icon small class="mr-2" color="primary"
                      >mdi-phone</v-icon
                    >
                    <span class="text-danger">*</span> Phone No
                  </h4>
                  <v-text-field
                    v-model="selectedMember.MobileNo"
                    :rules="MobileNoRules"
                    :counter="10"
                    v-mask="'##########'"
                    placeholder="Enter phone number"
                    outlined
                    dense
                    rounded
                    class="form-control"
                    prepend-inner-icon="mdi-phone-lock"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  v-if="selectedMember.MemberId > 0 && MemberType != 3"
                >
                  <h4 class="field-label">
                    <v-icon small class="mr-2" color="primary"
                      >mdi-gender-male-female</v-icon
                    >
                    <span class="text-danger">*</span> Gender
                  </h4>
                  <v-select
                    :reduce="(option) => option.value"
                    v-model="selectedMember.Gender"
                    :items="GenderOptions"
                    :rules="GenderRules"
                    required
                    outlined
                    dense
                    rounded
                    class="form-control"
                  ></v-select>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  v-if="selectedMember.MemberId > 0 && MemberType != 3"
                >
                  <h4 class="field-label">
                    <v-icon small class="mr-2" color="primary"
                      >mdi-silverware-fork-knife</v-icon
                    >
                    <span class="text-danger">*</span> Food Preference
                  </h4>
                  <v-select
                    :reduce="(option) => option.value"
                    v-model="selectedMember.FoodChoice"
                    :items="FoodPreferenceOptions"
                    :rules="FoodPreferenceRules"
                    required
                    outlined
                    dense
                    rounded
                    class="form-control"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3" v-if="selectedMember.MemberId > 0">
                  <h4 class="field-label">
                    <v-icon small class="mr-2" color="primary"
                      >mdi-receipt</v-icon
                    >
                    GST Bill
                    <small class="ml-1 text--secondary">(optional)</small>
                  </h4>
                  <v-select
                    :reduce="(option) => option.value"
                    v-model="selectedMember.GstNumberFlag"
                    :items="GstNumberFlagOptions"
                    :rules="GstNumberFlagRules"
                    required
                    outlined
                    dense
                    rounded
                    class="form-control"
                  ></v-select>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  v-if="
                    selectedMember.MemberId > 0 &&
                    selectedMember.GstNumberFlag == 1
                  "
                >
                  <h4 class="field-label">
                    <v-icon small class="mr-2" color="primary"
                      >mdi-card-text</v-icon
                    >
                    <span class="text-danger">*</span> GST Number
                  </h4>
                  <v-text-field
                    v-model="selectedMember.GstNumber"
                    :rules="GstNumberRules"
                    :counter="15"
                    v-mask="'##AAAAA####A#ZN'"
                    placeholder="Enter GST number"
                    dense
                    rounded
                    outlined
                    class="form-control"
                    prepend-inner-icon="mdi-identifier"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3" v-if="selectedMember.MemberId > 0">
                  <h4 class="field-label">
                    <v-icon small class="mr-2" color="primary"
                      >mdi-shirt-crew-neck</v-icon
                    >
                    <span class="text-danger">*</span> T-shirt Size
                  </h4>
                  <v-select
                    :reduce="(option) => option.value"
                    v-model="TshirtSize"
                    :items="TshirtSizeOptions"
                    :rules="TshirtSizeRules"
                    required
                    outlined
                    dense
                    rounded
                    class="form-control"
                  ></v-select>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  v-if="selectedMember.MemberId > 0 && AspacFlag"
                >
                  <h4 class="field-label">
                    <v-icon small class="mr-2" color="primary"
                      >mdi-passport</v-icon
                    >
                    <span class="text-danger">*</span> Passport Number
                  </h4>
                  <v-text-field
                    v-model="PassportNumber"
                    :rules="PassportNumberRules"
                    placeholder="Enter passport number"
                    dense
                    rounded
                    outlined
                    class="form-control"
                    prepend-inner-icon="mdi-identifier"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  v-if="selectedMember.MemberId > 0"
                >
                  <h4 class="field-label">
                    <v-icon small class="mr-2" color="primary">mdi-star</v-icon>
                    Senator Number
                    <small class="ml-1 text--secondary">(optional)</small>
                  </h4>
                  <v-text-field
                    v-model="SenatorNumber"
                    :rules="SenatorNumberRules"
                    placeholder="Applicable if contributed Senator title"
                    dense
                    rounded
                    outlined
                    class="form-control"
                    prepend-inner-icon="mdi-shield-star"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Participant Details Card -->
          <v-card elevation="8" class="form-card mb-6" v-if="MemberType == 3">
            <div
              class="form-card-header d-flex align-center justify-space-between"
            >
              <div class="d-flex align-center">
                <v-icon large class="header-icon"
                  >mdi-account-group-outline</v-icon
                >
                <div class="ml-4">
                  <h2 class="form-card-title">Participant Details</h2>
                  <p class="form-card-subtitle mb-0">
                    Manage participants for this registration
                  </p>
                </div>
              </div>
              <v-btn
                color="warning"
                class="font-weight-bold elevation-4"
                rounded
                small
                @click.prevent="openNonMemberDialog"
              >
                <v-icon left small>mdi-account-plus</v-icon>
                Add Participant
              </v-btn>
            </div>
            <v-divider class="my-0"></v-divider>
            <v-card-text class="pt-6">
              <v-row wrap>
                <v-col cols="12" sm="12" lg="12" md="12" id="step9">
                  <div class="table-wrapper">
                    <v-data-table
                      :headers="tableColumns2"
                      :items="AllParticipants"
                      hide-default-footer
                      disable-sort
                      id="document-table"
                      class="professional-table"
                    >
                      <template v-slot:no-data>
                        <div class="table-empty-state">
                          <v-icon large color="primary" class="empty-icon"
                            >mdi-account-multiple-plus</v-icon
                          >
                          <p>No participants added yet</p>
                          <v-btn
                            color="primary"
                            @click.prevent="addNonMemberRecordPrompt = true"
                            class="add-btn"
                          >
                            <v-icon left>mdi-plus</v-icon>
                            Add Participant
                          </v-btn>
                        </div>
                      </template>
                      <template v-slot:header="{ props }">
                        <thead>
                          <tr class="table-header-row">
                            <th
                              v-for="header in props.headers"
                              :key="header.value"
                              class="table-header-cell"
                            >
                              <div class="header-content">
                                <v-icon x-small class="header-icon">{{
                                  getHeaderIcon(header.value)
                                }}</v-icon>
                                <span>{{ header.text }}</span>
                              </div>
                            </th>
                          </tr>
                        </thead>
                      </template>
                      <template v-slot:item="props">
                        <tr
                          class="table-body-row"
                          :class="
                            props.index % 2 === 0 ? 'zebra-even' : 'zebra-odd'
                          "
                        >
                          <td
                            v-for="header in props.headers"
                            :key="header.value"
                            class="table-cell"
                          >
                            <div
                              v-if="header.value !== 'action'"
                              class="cell-content"
                            >
                              {{ props.item[header.value] }}
                            </div>
                            <div v-else class="action-buttons">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    icon
                                    small
                                    color="primary"
                                    @click.prevent="openNonMemberDialog"
                                    v-bind="attrs"
                                    v-on="on"
                                    class="action-btn"
                                  >
                                    <v-icon small>mdi-plus-circle</v-icon>
                                  </v-btn>
                                </template>
                                <span>Add Participant</span>
                              </v-tooltip>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    icon
                                    small
                                    color="error"
                                    @click="
                                      deleteRow(1, props.index, props.item)
                                    "
                                    v-bind="attrs"
                                    v-on="on"
                                    class="action-btn"
                                  >
                                    <v-icon small>mdi-delete-circle</v-icon>
                                  </v-btn>
                                </template>
                                <span>Delete Participant</span>
                              </v-tooltip>
                            </div>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Total Participants Card -->
          <v-card
            elevation="8"
            class="form-card qty-card mb-6"
            v-if="
              AllParticipants.length > 0 ||
              (MemberType !== '' && MemberType <= 2 && Qty > 0)
            "
          >
            <div class="form-card-header">
              <v-icon large class="header-icon">mdi-counter</v-icon>
              <div class="ml-4">
                <h2 class="form-card-title">Total Participants</h2>
                <p class="form-card-subtitle">
                  Summary of registered participants
                </p>
              </div>
            </div>
            <v-divider class="my-0"></v-divider>
            <v-card-text class="pt-6">
              <v-row align="center" justify="center">
                <v-col cols="12" md="6">
                  <div class="qty-display">
                    <div class="qty-value font-weight-black">
                      <strong>{{ Qty }}</strong>
                    </div>
                    <div class="qty-label">Participants</div>
                  </div>
                </v-col>
                <v-col cols="12" md="6" v-if="QtyFlag">
                  <v-text-field
                    v-model="Qty"
                    outlined
                    dense
                    rounded
                    type="number"
                    placeholder="Enter quantity"
                    prepend-inner-icon="mdi-plus-minus"
                    class="form-control"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-dialog v-model="PreviewPlanFlag" width="500">
            <event-plan-details
              :Plan="PreviewPlanDetails"
              @hideDialog="hidePreviewPlanPopup($event)"
              v-if="PreviewPlanFlag"
            ></event-plan-details>
          </v-dialog>

          <!-- Plans Section Header -->
          <div class="plans-section-header">
            <span class="section-badge">AVAILABLE PLANS</span>
            <h2 class="section-title">Choose Your Registration Plan</h2>
            <p class="section-subtitle">
              Select a plan and proceed to secure your reservation
            </p>

            <!-- EXISTING PLAN CARD FOR UPGRADES -->
            <div
              class="existing-plan-card-wrapper my-4"
              v-if="
                MemberType != 3 &&
                Plans &&
                Plans.length > 0 &&
                Plans[0].UpgradeFlag &&
                Plans[0].ExistingPlanName
              "
            >
              <div class="existing-plan-card">
                <div class="existing-plan-card-header">
                  <v-chip
                    color="orange darken-2"
                    outlined
                    small
                    class="font-weight-bold"
                  >
                    <i class="mdi mdi-arrow-up-bold-circle mr-1"></i> UPGRADE
                    AVAILABLE
                  </v-chip>
                </div>
                <div class="existing-plan-card-body">
                  <span class="existing-plan-text">
                    Existing Plan:
                    <strong class="existing-plan-name">{{
                      Plans[0].ExistingPlanName
                    }}</strong>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <v-row justify="center" class="plans-grid-row">
            <template v-for="(item, index) in Plans">
              <v-col
                :key="index"
                cols="12"
                sm="6"
                md="4"
                lg="4"
                class="plan-card-col"
              >
                <!-- RECOMMENDED PLAN CARD -->
                <div v-if="item.Recommended" class="h-100">
                  <div class="cards-box" v-if="item.PlanVisibleFlag">
                    <div
                      class="cards popular luxury-plan-card recommended-card"
                    >
                      <!-- 3D Folded Metallic Gold Ribbon -->
                      <div class="luxury-3d-ribbon">
                        <div class="ribbon-shine"></div>
                        <span>⭐ MOST POPULAR</span>
                      </div>

                      <!-- Continuous Diagonal Shimmer Light & Silvery Sheen -->
                      <div class="silvery-shine-sweep"></div>
                      <div class="card-shimmer-sweep"></div>
                      <div class="card-glow-aura"></div>

                      <div class="cards-title-bar">
                        <h3 class="cards-title gold-title">
                          {{ item.PlanName }}
                        </h3>

                        <!-- UPGRADE BANNER -->
                        <div v-if="item.UpgradeFlag" class="upgrade-info-card">
                          <div class="upgrade-badge-header">
                            <v-chip color="warning" small class="upgrade-pill">
                              <i class="mdi mdi-arrow-up-circle mr-1"></i> PLAN
                              UPGRADE
                            </v-chip>
                          </div>

                          <div class="upgrade-details-list">
                            <div
                              class="upgrade-detail-row"
                              v-if="
                                item.OriginalSubTotalTxt ||
                                item.OriginalTotalAmountTxt
                              "
                            >
                              <span class="detail-label">Original Price:</span>
                              <span class="detail-value highlight-gold">
                                {{
                                  item.OriginalSubTotalTxt ||
                                  item.OriginalTotalAmountTxt
                                }}
                              </span>
                            </div>
                            <div
                              class="upgrade-detail-row"
                              v-if="item.ExistingPlanAmountTxt"
                            >
                              <span class="detail-label">Paid Credit:</span>
                              <span class="detail-value highlight-emerald">
                                - {{ item.ExistingPlanAmountTxt }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="cards-price">
                        <div
                          v-if="item.UpgradeFlag"
                          class="upgrade-pending-txt mb-2"
                        >
                          Pending Payable Amount:
                        </div>
                        <h4 class="cards-price-amount">
                          {{ item.SubTotalTxt || item.TotalAmountTxt }}
                          <br v-if="item.TaxAmountTxt" />
                          <span class="cards-price-gst" v-if="item.TaxAmountTxt"
                            >+ {{ item.TaxAmountTxt }} GST</span
                          >
                          <small class="cards-price-validity">per pax</small>
                        </h4>

                        <div class="my-2">
                          <v-btn
                            color="warning"
                            outlined
                            rounded
                            small
                            class="show-details-btn"
                            @click.prevent="showPreviewPlanPopup(item)"
                          >
                            <i class="mdi mdi-eye-outline mr-1"></i> Show Plan
                            Details
                          </v-btn>
                        </div>
                      </div>

                      <div class="cards-total-box">
                        <div class="total-divider"></div>
                        <div class="total-amount-single-line">
                          <span class="total-amount-label">Total Amount:</span>
                          <span class="total-amount-value"
                            >₹ {{ formatCurrency(item.TotalAmount) }}</span
                          >
                        </div>
                      </div>

                      <div class="cards-action mt-4">
                        <button
                          class="cards-action-button gold-action-btn"
                          :disabled="!valid1"
                          @click.prevent="confirmAlert(item)"
                        >
                          <span class="btn-text">{{
                            item.ButtonText || "Pay now"
                          }}</span>
                          <i class="mdi mdi-arrow-right btn-arrow"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- STANDARD OR UPGRADE PLAN CARD -->
                <div v-else class="h-100">
                  <div class="cards-box" v-if="item.PlanVisibleFlag">
                    <div
                      class="cards luxury-plan-card"
                      :class="
                        item.UpgradeFlag
                          ? 'emerald-upgrade-card'
                          : 'standard-card'
                      "
                    >
                      <div class="silvery-shine-sweep"></div>
                      <div class="card-shimmer-sweep"></div>
                      <div class="card-glow-aura"></div>

                      <div class="cards-title-bar">
                        <h3
                          class="cards-title"
                          :class="item.UpgradeFlag ? 'emerald-title' : ''"
                        >
                          {{ item.PlanName }}
                        </h3>

                        <!-- UPGRADE BANNER FOR NON-RECOMMENDED -->
                        <div v-if="item.UpgradeFlag" class="upgrade-info-card">
                          <div class="upgrade-badge-header">
                            <v-chip color="success" small class="upgrade-pill">
                              <i class="mdi mdi-arrow-up-bold-circle mr-1"></i>
                              PLAN UPGRADE
                            </v-chip>
                          </div>

                          <div class="upgrade-details-list">
                            <div
                              class="upgrade-detail-row"
                              v-if="
                                item.OriginalSubTotalTxt ||
                                item.OriginalTotalAmountTxt
                              "
                            >
                              <span class="detail-label">Original Price:</span>
                              <span class="detail-value highlight-gold">
                                {{
                                  item.OriginalSubTotalTxt ||
                                  item.OriginalTotalAmountTxt
                                }}
                              </span>
                            </div>
                            <div
                              class="upgrade-detail-row"
                              v-if="item.ExistingPlanAmountTxt"
                            >
                              <span class="detail-label">Paid Credit:</span>
                              <span class="detail-value highlight-emerald">
                                - {{ item.ExistingPlanAmountTxt }}
                              </span>
                            </div>
                          </div>
                        </div>

                        <h4 class="cards-subtitle" v-if="item.PlanDescription">
                          {{ item.PlanDescription }}
                        </h4>
                      </div>

                      <div class="cards-price">
                        <div
                          v-if="item.UpgradeFlag"
                          class="upgrade-pending-txt mb-2"
                        >
                          Pending Payable Amount:
                        </div>
                        <h4 class="cards-price-amount">
                          {{ item.SubTotalTxt || item.TotalAmountTxt }}
                          <br v-if="item.TaxAmountTxt" />
                          <span class="cards-price-gst" v-if="item.TaxAmountTxt"
                            >+ {{ item.TaxAmountTxt }} GST</span
                          >
                          <small class="cards-price-validity">per pax</small>
                        </h4>

                        <div class="my-2">
                          <v-btn
                            :color="item.UpgradeFlag ? 'success' : 'primary'"
                            outlined
                            rounded
                            small
                            class="show-details-btn"
                            @click.prevent="showPreviewPlanPopup(item)"
                          >
                            <i class="mdi mdi-eye-outline mr-1"></i> Show Plan
                            Details
                          </v-btn>
                        </div>
                      </div>

                      <div class="cards-total-box">
                        <div class="total-divider"></div>
                        <div class="total-amount-single-line">
                          <span class="total-amount-label">Total Amount:</span>
                          <span class="total-amount-value"
                            >₹ {{ formatCurrency(item.TotalAmount) }}</span
                          >
                        </div>
                      </div>

                      <div class="cards-action mt-4">
                        <button
                          class="cards-action-button"
                          :class="
                            item.UpgradeFlag
                              ? 'emerald-action-btn'
                              : 'standard-action-btn'
                          "
                          :disabled="!valid1"
                          @click.prevent="confirmAlert(item)"
                          :loading="SubmitFlag"
                        >
                          <span class="btn-text">{{
                            item.ButtonText ||
                            (item.UpgradeFlag ? "⬆ Upgrade Now" : "Pay now")
                          }}</span>
                          <i class="mdi mdi-arrow-right btn-arrow"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </template>
          </v-row>
        </v-form>
      </v-container>
      <br /><br />
    </div>
  </div>
</template>

<script>
/* global Razorpay */
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import AddSmaNonMember from "@/view/pages/erp/events/sma-natcon/AddSmaNonMember.vue";
import EventPlanDetails from "@/view/pages/erp/events/natcon/EventPlanDetails.vue";

export default {
  mixins: [common],
  components: {
    AddSmaNonMember,
    EventPlanDetails,
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      StartupLoadingFlag: false,
      ProgressLoadingFlag: false,
      SubmitFlag: false,
      SearchFlag: false,
      NotesFlag: false,
      rows: [],
      tableColumns1: [],

      AspacFlag: false,

      PreviewPlanFlag: false,
      PreviewPlanDetails: {},

      selected: [],
      search: "",

      MemberPaymentLink: "",
      RegisterDetailsTxt: "Member Details",

      RegistrationTypeId: "",

      Qty: "",
      QtyFlag: false,
      QtyRules: [
        (v) => Number.isInteger(Number(v)) || "Nos is invalid",
        (v) => v > 0 || "Number must be greater than zero",
        (v) => v < 7 || "Number must be less than 6",
      ],

      MemberType: "",
      MemberTypeRules: [(v) => !!v || "Member type is required"],
      MemberTypeOptions: [
        { value: "", text: "--Select Type--" },
        { value: 1, text: "For me" },
        { value: 2, text: "For another member" },
      ],

      Gender: "",
      GenderRules: [(v) => !!v || "Gender is required"],
      GenderOptions: [
        { value: "", text: "--Select--" },
        { value: 1, text: "Male" },
        { value: 2, text: "Female" },
        { value: 3, text: "Other" },
      ],

      FoodPreference: "",
      FoodPreferenceRules: [(v) => !!v || "Food preference is required"],
      FoodPreferenceOptions: [
        { value: "", text: "--Select--" },
        { value: 1, text: "Veg" },
        { value: 2, text: "Non Veg" },
      ],

      MemberTypeId: 1,

      Lom: {},

      Member: {},

      Presidentmember: {},
      Plans: [],

      selectedPlan: {},
      selectedMember: {},

      MobileNoRules: [(v) => !!v || "Mobile No is required"],

      EmailIdRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],

      TshirtSize: "",
      TshirtSizeRules: [(v) => !!v || "T-Shirt size is required"],
      TshirtSizeOptions: [
        { value: "", text: "--Select--" },
        { value: "S", text: "S" },
        { value: "M", text: "M" },
        { value: "L", text: "L" },
        { value: "XL", text: "XL" },
        { value: "XXL", text: "XXL" },
        { value: "3XL", text: "3XL" },
        { value: "4XL", text: "4XL" },
        { value: "5XL", text: "5XL" },
      ],

      PassportNumber: "",
      PassportNumberRules: [(v) => !!v || "Passport number is required"],

      SenatorNumber: "",
      SenatorNumberRules: [],

      Events: {},

      MemberIdRules: [(v) => !!v || "Member is required"],
      MemberId: "",
      MemberIdOptions: [],
      MemberIdOptionsLoading: false,

      CheckoutTableHeaders: [],

      tab: null,
      TabDisable1: false,
      TabDisable2: false,

      TotalAmount: 0,
      Contribution: [],

      TotalAmount1: 0,
      TotalAmount2: 0,

      MemberImageFlag: false,

      PenaltySubscription: [],

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      OrderType: 1,

      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCodeOptions: [],
      JciYearCodeOptionsLoading: false,

      GstNumberFlag: 2,
      GstNumberFlagRules: [],
      GstNumberFlagOptions: [
        { value: "", text: "--Select--" },
        { value: 1, text: "Yes" },
        { value: 2, text: "No" },
      ],

      GstNumber: "",
      GstNumberRules: [(v) => !!v || "GST number is required"],

      ZoneCode: "",
      LomCode: "",
      UserMemberId: "",

      EventId: "",
      EventTypeId: 10,

      addNonMemberRecordPrompt: false,
      ParticipantMaxLimit: 6,
      AllParticipants: [],
      NonMemberDetails: {},
      uploadedParticipantImages: [],
      tableColumns2: [
        { text: "Participant Name", value: "ParticipantName" },
        { text: "Gender", value: "Gender" },
        { text: "Age", value: "Age" },
        { text: "Mobile number", value: "MobileNo" },
        { text: "Email Id", value: "EmailId" },
        { text: "Food", value: "Food" },
        { text: "Action", value: "action" },
      ],

      Order: {
        back_url: "",
        customer_name: "",
        customer_email_id: "",
        customer_mobile_no: "",
        rzp_action: "#",
        rzp_account_id: "",
        rzp_key: "bdgzbd",
        rzp_amount: "",
        rzp_order_id: "",
        rzp_buttontext: "Pay now",
        rzp_name: "JCI India Foundation",
        rzp_description: "",
        rzp_image: "",
        rzp_color: "#0096d5",
      },

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      RoleId: "",
    };
  },
  computed: {},
  mounted() {
    /*
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vuetify", route: "alerts" },
      { title: "Form Inputs & Control", route: "autocompletes" },
      { title: "Fileinptus" },
    ]);
    */
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = CurrentJciYearId;

        var UserMemberId = this.$session.get("MemberId");
        this.UserMemberId = UserMemberId;
        console.log({ UserMemberId });

        var ZoneId = this.$session.get("ZoneId");
        this.ZoneCode = ZoneId;
        console.log({ ZoneId });

        var LomId = this.$session.get("LomId");
        this.LomCode = LomId;
        console.log({ LomId });

        var RoleId = this.$session.get("RoleId");
        RoleId = RoleId == (null || undefined) ? "" : RoleId;
        console.log({ RoleId });
        this.RoleId = RoleId;
        var MemberPaymentLink =
          RoleId == 9
            ? "/natcon/payment/create"
            : "/natcon/member-payment/create";
        console.log({ MemberPaymentLink });
        this.MemberPaymentLink = MemberPaymentLink;

        var AspacFlag = this.AspacFlag;
        console.log({ AspacFlag });

        let MemberTypeOptions = [];
        if (AspacFlag) {
          MemberTypeOptions = [
            { value: "", text: "--Select Type--" },
            { value: 1, text: "For me" },
          ];
        } else {
          if (RoleId == 9) {
            MemberTypeOptions = [
              { value: "", text: "--Select Type--" },
              { value: 2, text: "For member" },
              { value: 3, text: "For Spouse & Relatives" },
            ];
          } else {
            MemberTypeOptions = [
              { value: "", text: "--Select Type--" },
              { value: 1, text: "For me" },
              { value: 2, text: "For another member" },
              { value: 3, text: "For Spouse & Relatives" },
            ];
          }
        }
        console.log({ MemberTypeOptions });
        this.MemberTypeOptions = MemberTypeOptions;

        this.pageData();
      }
    },
    JciYearCodeOptions: function () {
      console.log("watch JciYearCodeOptions");
      this.LoadingFlag = false;
      this.JciYearCodeOptionsLoading = false;
    },
    Qty: function () {
      console.log("watch Qty");
      var Qty = this.Qty;
      Qty = Qty == (null || undefined || isNaN(Qty)) ? 0 : parseFloat(Qty);
      console.log({ Qty });
      var Plans = this.Plans;
      console.log({ Plans });
      var newPlans = [];
      Plans.forEach((item) => {
        console.log({ item });
        var temp = item;
        var Amount = parseFloat(item.SubTotalAmount);
        console.log({ Amount });
        var TotalAmount = Qty * Amount;
        TotalAmount =
          TotalAmount == (null || undefined || isNaN(TotalAmount))
            ? 0
            : parseFloat(TotalAmount);
        console.log({ TotalAmount });
        temp.Qty = Qty;
        temp.TotalAmount = TotalAmount;
        newPlans.push(temp);
      });
      this.Plans = newPlans;
    },
    MemberIdOptions: function () {
      this.MemberIdOptionsLoading = false;
    },
    MemberId: function () {
      console.log("watch MemberId");
      if (this.MemberType == 2 && this.MemberId != "") {
        this.getSelectedMemberDetails();
      }
    },
    MemberType: function () {
      console.log("watch MemberType");
      this.selectedMember = {};
      var MemberType = this.MemberType;
      console.log("MemberType=" + MemberType);
      if (MemberType != "") {
        this.AllParticipants = [];
        this.Qty = 0;
        var Member = this.Member;
        console.log({ Member });
        var MemberId = Member.MemberId;
        console.log({ MemberId });
        var tempData = {
          MemberFlag: true,
          MemberId: MemberId,
          MembershipId: Member.MembershipId,
          MemberName: Member.Fullname,
          Age: "",
          MobileNo: Member.MobileNo,
          EmailId: Member.EmailId,
          Gender: Member.Gender,
          FoodChoice: Member.FoodChoice,
          MemberImagePath: Member.MemberImage,
          action: "",
        };
        console.log({ tempData });
        if (MemberType == 1) {
          this.RegisterDetailsTxt = "Member Details";
          // this.AllParticipants.push(tempData);
          this.selectedMember = tempData;
          this.Qty = 1;
          this.MemberId = MemberId;
          this.getEventsDetails();
        } else if (MemberType == 2) {
          this.MemberId = "";
          this.RegisterDetailsTxt = "Member Details";
          this.getSelectedMemberDetails();
        } else {
          this.RegisterDetailsTxt = "Payee Details";
          this.selectedMember = tempData;
          this.MemberId = MemberId;
          this.getEventsDetails();
        }
      }
    },
  },
  methods: {
    formatCurrency(amount) {
      if (amount === null || amount === undefined || amount === "")
        return "0.00";
      var num = parseFloat(amount);
      if (isNaN(num)) return "0.00";
      return num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    getHeaderIcon(headerValue) {
      const iconMap = {
        ParticipantName: "mdi-account",
        Gender: "mdi-gender-male-female",
        Age: "mdi-calendar",
        MobileNo: "mdi-phone",
        EmailId: "mdi-email",
        Food: "mdi-silverware-fork-knife",
        action: "mdi-cog",
      };
      return iconMap[headerValue] || "mdi-dots-horizontal";
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      // this.resetForm();
      var id = this.$route.query.id;
      console.log({ id });
      this.EventId = id;
      var url1 = "api/jci-program/show";
      var condition1 = {
        UserInterface: 1,
        Program: id,
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.getMemberDetails();
      this.getMemberIdOptions();
      this.getLomDetails();
      this.getEventsDetails();
    },
    getLomDetails() {
      console.log("getLomDetails is called");
      var LomId = this.LomCode;
      console.log("LomId=" + LomId);
      if (LomId != "") {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom/show";
        var upload = {
          UserInterface: 2,
          Lom: LomId,
        };
        const thisIns = this;
        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            console.log("getLomDetails response=", response);
            if (response.data.flag == 1) {
              thisIns.Lom = response.data.records;
            }
          })
          .catch(function (error) {
            console.log("getLomDetails error=" + error);
          });
      }
    },
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    addRecord() {
      console.log("addRecord called");
      var url = "/staff/list";
      var params = {};
      this.pageRedirect(params, url);
    },
    resetForm() {
      this.$refs.form2.reset();
      this.selectedMember = {};
      this.selectedPlan = {};
      // this.refreshPageData();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    openNonMemberDialog() {
      console.log("openNonMemberDialog called");
      var n2 = this.AllParticipants.length;
      console.log({ n2 });
      var m2 = this.ParticipantMaxLimit;
      console.log({ m2 });
      if (n2 < m2) {
        this.addNonMemberRecordPrompt = true;
      } else {
        var message = "Participant maximum limit " + m2 + " reached. ";
        this.sweetAlert("error", message, false);
      }
    },
    showPreviewPlanPopup(tr) {
      this.PreviewPlanDetails = tr;
      this.PreviewPlanFlag = true;
    },
    hidePreviewPlanPopup() {
      this.PreviewPlanDetails = {};
      this.PreviewPlanFlag = false;
    },
    setQty() {
      console.log("setQty called");
      var MemberType = this.MemberType;
      if (MemberType === 1) {
        this.Qty = 1;
      } else if (MemberType === 2) {
        this.Qty =
          this.selectedMember && this.selectedMember.MemberId > 0 ? 1 : 0;
      } else if (MemberType === 3) {
        this.Qty = this.AllParticipants.length;
      } else {
        this.Qty = 0;
      }
    },
    addNewNonMember(member) {
      console.log("addNewNonMember called");
      this.addNonMemberRecordPrompt = false;
      console.log({ member });
      this.NonMemberDetails = member;
      this.addNewRow(1);
    },
    addNewRow(tableId) {
      console.log("addNewRow called");

      console.log("tableId=" + tableId);

      switch (tableId) {
        case 1:
          var n2 = this.AllParticipants.length;
          console.log({ n2 });
          var MemberFlag = this.NonMemberDetails.MemberFlag;
          MemberFlag = MemberFlag == (null || undefined) ? false : MemberFlag;
          console.log({ MemberFlag });
          var m2 = this.ParticipantMaxLimit;
          console.log({ m2 });
          if (n2 < m2) {
            if (MemberFlag) {
              this.AllParticipants.push(this.NonMemberDetails);
              this.setQty();
            }
          } else {
            var message = "Participant maximum limit " + m2 + " reached. ";
            this.sweetAlert("error", message, false);
          }
          this.NonMemberDetails = {};
          break;

        default:
          break;
      }
    },
    deleteRow(tableId, index, tr) {
      console.log("deleteRow called");
      console.log({ tableId });
      console.log({ index });
      console.log({ tr });
      if (index >= 0) {
        switch (tableId) {
          case 1:
            this.AllParticipants.splice(index, 1);
            this.setQty();
            break;

          default:
            break;
        }
      }
    },
    getMemberIdOptions() {
      console.log("getMemberIdOptions called");
      var RoleId = this.RoleId;
      console.log({ RoleId });
      var UserInterface = RoleId == 9 ? 4 : 2;
      console.log({ UserInterface });
      var selectbox1_source = "MemberId";
      var selectbox1_destination = "MemberIdOptions";
      var selectbox1_url = "api/members/options";
      var selectbox1_conditions_array = {
        UserInterface: 2,
        LomCode: this.LomCode,
        MemberType: this.MemberTypeId,
        MemberTypeFlag: true,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getSelectedMemberDetails() {
      console.log("getSelectedMemberDetails called");
      this.selectedMember = {};
      this.AllParticipants = [];
      var temp_code = this.MemberId;
      console.log("temp_code=" + temp_code);
      var idx = this.MemberIdOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx >= 0) {
        var member = this.MemberIdOptions[idx];
        console.log("member=" + JSON.stringify(member));
        var tempData = {
          MemberFlag: true,
          MemberId: member.value,
          MembershipId: member.membership_id,
          MemberName: member.member_name,
          Gender: member.gender,
          FoodChoice: member.food_choice,
          Age: "",
          MobileNo: member.mobile_no || member.MobileNo || "",
          EmailId: member.email_id || member.EmailId || "",
          MemberImagePath: member.photo,
          action: "",
        };
        // this.AllParticipants.push(tempData);
        this.selectedMember = tempData;
        this.Qty = 1;
        this.getEventsDetails();
      } else {
        this.Qty = 0;
      }
    },
    getMemberDetails() {
      console.log("getMemberDetails is called");

      var MemberId = this.UserMemberId;
      var ZoneCode = this.ZoneCode;
      var LomCode = this.LomCode;
      console.log(
        "MemberId=" +
          MemberId +
          "; ZoneCode=" +
          ZoneCode +
          "; LomCode=" +
          LomCode
      );

      if (MemberId != "" && ZoneCode != "" && LomCode != "") {
        this.LoadingFlag = true;
        this.Member = {};

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members/search";
        var upload = {
          UserInterface: 4,
          MemberId: MemberId,
          ZoneCode: ZoneCode,
          LomCode: LomCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.Member = records;
              if (thisIns.MemberType == 1 || thisIns.MemberType == 3) {
                var Member = records;
                var MemberId = Member.MemberId;
                var tempData = {
                  MemberFlag: true,
                  MemberId: MemberId,
                  MembershipId: Member.MembershipId,
                  MemberName: Member.Fullname,
                  Age: "",
                  MobileNo: Member.MobileNo,
                  EmailId: Member.EmailId,
                  Gender: Member.Gender,
                  FoodChoice: Member.FoodChoice,
                  MemberImagePath: Member.MemberImage,
                  action: "",
                };
                thisIns.selectedMember = tempData;
                thisIns.MemberId = MemberId;
                thisIns.getEventsDetails();
              }
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "";
        if (MemberId == "" || ZoneCode == "" || LomCode == "") {
          message += "Your session is expired. Kindly login again. ";
        }
        this.toast("error", message);
      }
    },
    getEventsDetails() {
      console.log("getEventsDetails is called");

      var EventCode = this.EventId || 8;
      var memberId = "";
      if (this.MemberType != 3) {
        memberId =
          this.selectedMember && this.selectedMember.MemberId
            ? this.selectedMember.MemberId
            : this.MemberId || "";
      }
      console.log("EventCode=" + EventCode + "; memberId=" + memberId);

      if (EventCode != "") {
        this.SubmitFlag = true;
        this.StartupLoadingFlag = true;
        this.Events = {};
        this.Plans = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/jci-program/plan/lists";
        var upload = {
          UserInterface: 2,
          Program: EventCode,
          ProgramType: 10,
          Member: memberId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SubmitFlag = false;
            thisIns.StartupLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.Plans = records.TableData;
              thisIns.setQty();
              // thisIns.toast("success", output);
              // thisIns.resetForm();
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
            thisIns.StartupLoadingFlag = false;
          });
      } else {
        var message = "";
        if (EventCode == "") {
          message += "Event Id should not be empty ";
        }
        this.toast("error", message);
      }
    },
    confirmAlert(selectedPlan) {
      console.log("confirmAlert called");

      var validate1 = this.$refs.form2.validate();
      console.log({ validate1 });

      var selectedMember = this.selectedMember;
      console.log({ selectedMember });

      var MemberType = this.MemberType;
      console.log({ MemberType });

      var RegistrationTypeId = MemberType <= 2 ? 3 : 4;
      console.log({ RegistrationTypeId });

      var MemberId = selectedMember.MemberId;
      MemberId = MemberId == (null || undefined) ? "" : MemberId;
      console.log({ MemberId });

      this.selectedPlan = selectedPlan;
      console.log({ selectedPlan });

      var EventPlanId = selectedPlan.EventPlanId;
      EventPlanId = EventPlanId == (null || undefined) ? "" : EventPlanId;
      console.log({ EventPlanId });

      var participants = this.AllParticipants;
      console.log({ participants });

      var TotalCount = this.Qty;
      console.log("TotalCount=" + TotalCount);

      var EventTotalAmount = selectedPlan.SubTotalAmount;
      console.log("EventTotalAmount=" + EventTotalAmount);

      var TotalAmount = parseFloat(TotalCount) * parseFloat(EventTotalAmount);
      console.log("TotalAmount=" + TotalAmount);

      if (validate1 && TotalCount > 0 && TotalAmount > 0 && MemberType > 0) {
        this.RegistrationTypeId = RegistrationTypeId;

        var MemberTxt = "";
        participants.forEach((item) => {
          console.log({ item });
          MemberTxt +=
            "<br/>" +
            item.ParticipantName +
            " &nbsp; - " +
            item.MobileNo +
            " &nbsp; - " +
            item.EmailId +
            " &nbsp; - " +
            item.Food;
        });
        var htmlTxt = "";
        htmlTxt += "<br/><b>Selected plan details</b>";
        htmlTxt += "<br/>Plan name <b>" + selectedPlan.PlanName + "</b>";
        htmlTxt += "<br/><br/><b>Selected participant details</b>";

        if (RegistrationTypeId == 3) {
          htmlTxt +=
            "<br/>Member Name <b>" + selectedMember.MemberName + "</b>";
          htmlTxt += "<br/>Mobile no. <b>" + selectedMember.MobileNo + "</b>";
          htmlTxt += "<br/>Email id <b>" + selectedMember.EmailId + "</b>";
          htmlTxt +=
            "<br/><img width='100' height='100' src='" +
            selectedMember.MemberImagePath +
            "' />";
        } else {
          htmlTxt +=
            "<br/><b> Member Name &nbsp; - Mobile no. &nbsp; - Email id &nbsp; - Food </b>";
          htmlTxt += MemberTxt;
        }

        htmlTxt += "<br/><br/>Total amount <b> ₹ " + TotalAmount + "</b>";
        htmlTxt += "<br/><br/>Do you want to continue?";
        Swal.fire({
          title: "Please verify all the information before proceeding",
          text: "",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Continue`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
            // this.makePayment();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (MemberId == "") {
          message += "Kindly select member. ";
        }
        if (EventPlanId == "") {
          message += "Kindly select plan. ";
        }
        if (TotalCount == 0) {
          if (MemberType == 3) {
            message += "Kindly add atleast one participant. ";
          } else {
            message += "Kindly select member. ";
          }
        }
        this.sweetAlert("error", message, false);
      }
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form2.validate();
      console.log({ validate1 });

      var selectedPlan = this.selectedPlan;
      console.log({ selectedPlan });

      var selectedMember = this.selectedMember;
      console.log({ selectedMember });

      var MemberType = this.MemberType;
      console.log({ MemberType });

      var RegistrationTypeId = this.RegistrationTypeId;
      console.log({ RegistrationTypeId });

      var MemberId = selectedMember.MemberId;
      MemberId = MemberId == (null || undefined) ? "" : MemberId;
      console.log({ MemberId });

      var EventPlanId = selectedPlan.EventPlanId;
      EventPlanId = EventPlanId == (null || undefined) ? "" : EventPlanId;
      console.log({ EventPlanId });

      var participants = this.AllParticipants;
      console.log({ participants });

      var TotalCount = this.Qty;
      console.log("TotalCount=" + TotalCount);

      var EventTotalAmount = selectedPlan.TotalAmount;
      console.log("EventTotalAmount=" + EventTotalAmount);

      var TotalAmount = parseFloat(TotalCount) * parseFloat(EventTotalAmount);
      console.log("TotalAmount=" + TotalAmount);

      if (
        validate1 &&
        TotalCount > 0 &&
        TotalAmount > 0 &&
        RegistrationTypeId > 0
      ) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/jci-program/order/create";
        var upload = {
          UserInterface: RegistrationTypeId,
          RegistrationType: RegistrationTypeId,
          Lom: this.LomCode,
          Member: MemberId,
          Event: this.EventId,
          Plan: EventPlanId,
          MobileNo: selectedMember.MobileNo,
          EmailId: selectedMember.EmailId,
          Gender: MemberType == 3 ? null : selectedMember.Gender,
          FoodPreference: MemberType == 3 ? null : selectedMember.FoodChoice,
          GstNumberFlag: selectedMember.GstNumberFlag,
          GstNumber:
            selectedMember.GstNumberFlag == 1 ? selectedMember.GstNumber : null,
          TshirtSize: this.TshirtSize,
          PassportNumber: this.PassportNumber,
          SenatorNumber: this.SenatorNumber,
          TotalCount: TotalCount,
          TotalAmount: TotalAmount,
          Participants: participants,
          UpgradeFlag: selectedPlan.UpgradeFlag || false,
          PlanTypeId: selectedPlan.UpgradeFlag ? 2 : 1,
          OldPlanId: selectedPlan.ExistingPlanId || null,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.SubmitFlag = true;
        this.ProgressLoadingFlag = true;

        // this.$session.set("checkout", upload);
        // this.checkout();

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SubmitFlag = false;
            thisIns.ProgressLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              /*
              thisIns.sweetAlert(
                "info",
                "You will be redirected to checkout page shortly",
                true
              );
              */
              thisIns.Order = records.Order;
              thisIns.makePayment();
            } else {
              // thisIns.toast("error", output);
              // thisIns.Order = records.Order;
              // thisIns.makePayment();
              thisIns.sweetAlert("info", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
            thisIns.ProgressLoadingFlag = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (TotalCount == 0) {
          if (MemberType == 3) {
            message += "Kindly add atleast one participant. ";
          } else {
            message += "Kindly select member. ";
          }
        }
        if (TotalAmount == 0) {
          message += "Kindly select a plan. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    makePayment() {
      console.log("makePayment");
      // ev.preventDefault();
      var order = this.Order;
      console.log({ order });
      const thisIns = this;
      var rzp1 = new Razorpay({
        key: order.rzp_key,
        account_id: order.rzp_account_id,
        order_id: order.rzp_order_id,
        amount: order.rzp_amount,
        name: order.rzp_name,
        currency: "INR",
        description: order.rzp_description,
        image: order.rzp_image,
        theme: {
          color: order.rzp_color,
        },
        prefill: {
          name: order.customer_name,
          email: order.customer_email_id,
          contact: order.customer_mobile_no,
        },
        notes: {
          address: "",
        },
        // callback_url: "http://domain.com/#/about/" + this.order_id,
        redirect: false,
        handler: function (response) {
          console.log("razorpay_payment_id=" + response.razorpay_payment_id);
          thisIns.SubmitFlag = true;
          // thisIns.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
          thisIns.pageRedirect({}, "/order/success");
        },
      });
      rzp1.open();
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap");

/* ==========================================================================
   JCSAT KIT PURCHASE SIGNATURE BLUE COLOR SYSTEM
   DEEP BLUE - #1E3A8A
   VIBRANT BLUE - #1565C0
   AQUA SKY - #0097D7
   GOLD ACCENT - #EDBE38
   SEAFOAM - #56BDA3
   Text: 90% Black (#414042), Off Black (#0A0F29), White (#FFFFFF)
   Background: Soft Light Blue-Grey (#F0F7FF)
   ========================================================================== */
$jci-deep-blue: #1e3a8a;
$jci-blue: #1565c0;
$jci-navy: #3a67b1;
$jci-aqua: #0097d7;
$jci-gold: #edbe38;
$jci-seafoam: #56bda3;

$jci-text-90black: #414042;
$jci-off-black: #0a0f29;
$jci-white: #ffffff;
$jci-bg-light: #f0f7ff;

#natcon-payment-create.natcon-luxury-app,
#natcon-member-payment-create.natcon-luxury-app,
#natcon-non-member-payment.natcon-luxury-app,
#natcon-member-payment.natcon-luxury-app {
  font-family: "Outfit", "Plus Jakarta Sans", sans-serif;
  background-color: $jci-bg-light;
  color: $jci-text-90black;
  min-height: 100vh;
  margin: -24px -24px 0 -24px;
  padding: 0;
  position: relative;
  overflow-x: hidden;

  /* Overrides for default Vuetify/Metronic card containers if wrapped */
  .v-card {
    background: transparent !important;
    box-shadow: none !important;
    border: none !important;
  }

  /* Overlay Spinner */
  .v-overlay.luxury-overlay {
    &:not(.v-overlay--active) {
      display: none !important;
    }

    &.v-overlay--active {
      backdrop-filter: blur(16px);
      -webkit-backdrop-filter: blur(16px);
      background: rgba(240, 247, 255, 0.9) !important;
    }

    .luxury-spinner-wrapper {
      text-align: center;
      .luxury-spinner-text {
        margin-top: 18px;
        color: $jci-blue;
        font-weight: 700;
        letter-spacing: 2px;
        text-transform: uppercase;
        font-size: 14px;
        animation: pulseText 1.8s infinite ease-in-out;
      }
    }
  }

  /* ==========================================================================
     1. HERO HEADER SECTION
     ========================================================================== */
  .luxury-hero-section {
    position: relative;
    min-height: 320px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 20px 48px 20px;
    background: linear-gradient(
      135deg,
      #1e3a8a 0%,
      #1565c0 50%,
      #0097d7 100%
    ) !important;
    background-size: 400% 400% !important;
    animation: gradientShift 15s ease infinite !important;
    overflow: hidden;
    color: #ffffff;

    /* Animated Background Layers */
    .mesh-gradient-bg {
      position: absolute;
      inset: 0;
      background: radial-gradient(
          at 0% 0%,
          rgba(30, 58, 138, 0.25) 0px,
          transparent 50%
        ),
        radial-gradient(
          at 100% 0%,
          rgba(21, 101, 192, 0.25) 0px,
          transparent 50%
        ),
        radial-gradient(
          at 50% 100%,
          rgba(237, 190, 56, 0.2) 0px,
          transparent 50%
        ),
        radial-gradient(
          at 100% 100%,
          rgba(0, 151, 215, 0.25) 0px,
          transparent 50%
        );
      filter: blur(40px);
      animation: meshMovement 20s ease-in-out infinite alternate;
      z-index: 1;
    }

    .aurora-lights {
      position: absolute;
      inset: 0;
      background: linear-gradient(
        125deg,
        rgba(255, 255, 255, 0.08),
        rgba(21, 101, 192, 0.06),
        rgba(0, 151, 215, 0.08)
      );
      background-size: 400% 400%;
      animation: auroraShift 15s ease infinite;
      z-index: 2;
    }

    .animated-glow-orbs {
      position: absolute;
      inset: 0;
      z-index: 2;
      pointer-events: none;

      .orb {
        position: absolute;
        border-radius: 50%;
        filter: blur(70px);
        opacity: 0.25;
      }
      .orb-1 {
        width: 220px;
        height: 220px;
        background: $jci-deep-blue;
        top: 10%;
        left: 15%;
        animation: floatOrb 12s ease-in-out infinite alternate;
      }
      .orb-2 {
        width: 260px;
        height: 260px;
        background: $jci-blue;
        bottom: 10%;
        right: 15%;
        animation: floatOrb 16s ease-in-out infinite alternate-reverse;
      }
      .orb-3 {
        width: 180px;
        height: 180px;
        background: $jci-gold;
        top: 40%;
        right: 35%;
        animation: floatOrb 10s ease-in-out infinite alternate;
      }
    }

    .moving-light-rays {
      position: absolute;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      background: conic-gradient(
        from 0deg at 50% 50%,
        rgba(255, 255, 255, 0.04) 0deg,
        transparent 60deg,
        rgba(0, 151, 215, 0.04) 120deg,
        transparent 180deg
      );
      animation: rotateRays 35s linear infinite;
      z-index: 2;
      pointer-events: none;
    }

    .glass-reflection-overlay {
      position: absolute;
      inset: 0;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.15) 0%,
        transparent 60%,
        rgba(240, 247, 255, 0.1) 100%
      );
      z-index: 3;
      pointer-events: none;
    }

    .soft-noise-overlay {
      position: absolute;
      inset: 0;
      opacity: 0.03;
      background-image: radial-gradient(#ffffff 1px, transparent 0);
      background-size: 24px 24px;
      z-index: 3;
      pointer-events: none;
    }

    /* Floating Decorative 3D Elements */
    .luxury-decorations {
      position: absolute;
      inset: 0;
      z-index: 4;
      pointer-events: none;

      .floating-element {
        position: absolute;
        opacity: 0.7;
      }

      .diamond {
        width: 20px;
        height: 20px;
        background: linear-gradient(135deg, #ffffff, rgba(0, 151, 215, 0.4));
        transform: rotate(45deg);
        box-shadow: 0 0 15px rgba(21, 101, 192, 0.25);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 4px;
        &.d1 {
          top: 15%;
          left: 8%;
          animation: floatSlow 8s ease-in-out infinite;
        }
      }

      .ring {
        width: 36px;
        height: 36px;
        border: 2px solid rgba(237, 190, 56, 0.5);
        border-radius: 50%;
        box-shadow: 0 0 20px rgba(237, 190, 56, 0.2);
        &.r1 {
          bottom: 20%;
          left: 12%;
          animation: floatSlow 11s ease-in-out infinite reverse;
        }
      }

      .circle {
        width: 14px;
        height: 14px;
        background: rgba(0, 151, 215, 0.5);
        border-radius: 50%;
        box-shadow: 0 0 12px rgba(0, 151, 215, 0.6);
        &.c1 {
          top: 22%;
          right: 10%;
          animation: floatSlow 9s ease-in-out infinite;
        }
      }

      .cube {
        width: 22px;
        height: 22px;
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(8px);
        border: 1px solid rgba(255, 255, 255, 0.25);
        border-radius: 6px;
        transform: rotate(15deg);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
        &.cb1 {
          bottom: 25%;
          right: 8%;
          animation: floatSlow 13s ease-in-out infinite;
        }
      }

      .golden-particle {
        width: 6px;
        height: 6px;
        background: $jci-gold;
        border-radius: 50%;
        box-shadow: 0 0 10px $jci-gold;
        &.p1 {
          top: 35%;
          left: 5%;
          animation: floatSlow 6s ease-in-out infinite;
        }
        &.p2 {
          top: 12%;
          right: 22%;
          animation: floatSlow 7s ease-in-out infinite reverse;
        }
      }

      .sparkle {
        color: $jci-gold;
        font-size: 15px;
        text-shadow: 0 0 12px $jci-gold;
        &.s1 {
          top: 18%;
          left: 25%;
          animation: pulseGlow 3s infinite alternate;
        }
        &.s2 {
          bottom: 30%;
          right: 25%;
          animation: pulseGlow 4s infinite alternate 1s;
        }
        &.s3 {
          top: 45%;
          right: 6%;
          animation: pulseGlow 2.5s infinite alternate 0.5s;
        }
      }

      .line {
        width: 90px;
        height: 1px;
        background: linear-gradient(
          90deg,
          transparent,
          rgba(255, 255, 255, 0.4),
          transparent
        );
        &.l1 {
          top: 28%;
          right: 18%;
          transform: rotate(-25deg);
          animation: floatSlow 10s ease-in-out infinite;
        }
      }

      .glow-wave {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        border: 1px solid rgba(255, 255, 255, 0.2);
        &.w1 {
          bottom: 10%;
          left: 30%;
          animation: pulseGlow 6s infinite alternate;
        }
      }
    }

    /* Hero Content & Glass Card - JCSAT KIT PURCHASE BLUE GRADIENT */
    .hero-content-wrapper {
      position: relative;
      z-index: 5;
      max-width: 1140px;
      width: 100%;
      text-align: center;

      .hero-glass-card {
        position: relative;
        background: rgba(255, 255, 255, 0.12);
        backdrop-filter: blur(28px);
        -webkit-backdrop-filter: blur(28px);
        border: 1px solid rgba(255, 255, 255, 0.25);
        border-radius: 24px;
        padding: 24px 28px;
        box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2),
          inset 0 1px 0 rgba(255, 255, 255, 0.4);
        overflow: hidden;
        animation: heroCardBreathing 8s ease-in-out infinite alternate;

        /* Floating 3D Glassy Bubble Animations */
        .hero-bubbles {
          position: absolute;
          inset: 0;
          overflow: hidden;
          pointer-events: none;
          z-index: 1;

          .bubble {
            position: absolute;
            bottom: -60px;
            border-radius: 50%;
            background: radial-gradient(
              circle at 32% 32%,
              rgba(255, 255, 255, 0.9) 0%,
              rgba(255, 255, 255, 0.4) 22%,
              rgba(0, 151, 215, 0.25) 50%,
              rgba(30, 58, 138, 0.15) 75%,
              rgba(255, 255, 255, 0.6) 100%
            );
            box-shadow: inset -4px -4px 12px rgba(255, 255, 255, 0.8),
              inset 4px 4px 14px rgba(0, 151, 215, 0.5),
              inset 0 -8px 18px rgba(237, 190, 56, 0.35),
              0 8px 25px rgba(0, 0, 0, 0.25), 0 0 15px rgba(255, 255, 255, 0.5);
            border: 1px solid rgba(255, 255, 255, 0.6);
            backdrop-filter: blur(4px);
            animation: floatUp3DBubble linear infinite;

            &::before {
              content: "";
              position: absolute;
              top: 14%;
              left: 16%;
              width: 28%;
              height: 28%;
              border-radius: 50%;
              background: radial-gradient(
                circle,
                #ffffff 0%,
                rgba(255, 255, 255, 0.8) 50%,
                transparent 100%
              );
              filter: blur(0.5px);
            }

            &::after {
              content: "";
              position: absolute;
              bottom: 12%;
              right: 14%;
              width: 40%;
              height: 20%;
              border-radius: 50%;
              background: rgba(255, 255, 255, 0.5);
              filter: blur(1.5px);
              transform: rotate(-30deg);
            }
          }

          .bubble-1 {
            width: 48px;
            height: 48px;
            left: 8%;
            animation-duration: 7s;
            animation-delay: 0s;
          }
          .bubble-2 {
            width: 32px;
            height: 32px;
            left: 24%;
            animation-duration: 9s;
            animation-delay: 1.5s;
          }
          .bubble-3 {
            width: 60px;
            height: 60px;
            left: 45%;
            animation-duration: 6s;
            animation-delay: 3s;
          }
          .bubble-4 {
            width: 28px;
            height: 28px;
            left: 65%;
            animation-duration: 8s;
            animation-delay: 0.5s;
          }
          .bubble-5 {
            width: 52px;
            height: 52px;
            left: 82%;
            animation-duration: 10s;
            animation-delay: 2s;
          }
          .bubble-6 {
            width: 36px;
            height: 36px;
            left: 93%;
            animation-duration: 7.5s;
            animation-delay: 4s;
          }
        }

        .hero-card-glow-border {
          position: absolute;
          inset: 0;
          border-radius: 24px;
          padding: 1px;
          background: linear-gradient(
            135deg,
            rgba(237, 190, 56, 0.8),
            transparent 40%,
            rgba(255, 255, 255, 0.6)
          );
          -webkit-mask: linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
          -webkit-mask-composite: destination-out;
          mask-composite: exclude;
          pointer-events: none;
        }

        .hero-card-shine-sweep {
          position: absolute;
          top: 0;
          left: -150%;
          width: 80%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.25),
            transparent
          );
          transform: skewX(-25deg);
          animation: shineSweep 9s infinite ease-in-out;
          pointer-events: none;
        }

        /* Badge */
        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 4px 14px;
          background: rgba(255, 255, 255, 0.18);
          border: 1px solid rgba(255, 255, 255, 0.4);
          border-radius: 100px;
          margin-bottom: 12px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);

          .badge-icon {
            font-size: 12px;
          }
          .badge-text {
            font-size: 10px;
            font-weight: 800;
            letter-spacing: 1.5px;
            color: $jci-gold;
            text-transform: uppercase;
          }
        }

        /* Typography */
        .hero-main-title {
          font-size: clamp(24px, 3.5vw, 36px);
          font-weight: 900;
          line-height: 1.15;
          letter-spacing: -0.5px;
          margin-bottom: 8px;
          color: $jci-white;
          background: none;
          -webkit-text-fill-color: $jci-white;
          text-shadow: 0 4px 15px rgba(0, 0, 0, 0.25);

          .text-gradient-sky {
            background: linear-gradient(90deg, #ffd54f 0%, #fff176 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-weight: 850;
          }
        }

        .hero-subtitle {
          font-size: 14px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.95);
          max-width: 900px;
          margin: 0 auto 16px auto;
          line-height: 1.5;
        }

        /* Information Glass Pills */
        .hero-pills-row {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 8px;
          margin-bottom: 18px;

          .hero-pill {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 6px 14px;
            background: rgba(255, 255, 255, 0.15);
            backdrop-filter: blur(12px);
            border: 1.5px solid #0097d7 !important;
            border-radius: 100px;
            font-size: 12px;
            color: #ffffff !important;
            box-shadow: 0 4px 12px rgba(0, 151, 215, 0.25);
            transition: all 0.3s ease;

            .pill-icon,
            i {
              font-size: 14px;
              color: #ffffff !important;
            }

            &:hover {
              background: rgba(255, 255, 255, 0.25);
              border-color: #ffffff !important;
              transform: translateY(-2px);
              box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2);
            }

            &.live-status {
              background: rgba(86, 189, 163, 0.25);
              border-color: rgba(86, 189, 163, 0.8) !important;
              color: #ffffff !important;

              .status-dot {
                width: 7px;
                height: 7px;
                background: #ffffff;
                border-radius: 50%;
                box-shadow: 0 0 8px #ffffff;
                animation: pulseGlow 1.5s infinite alternate;
              }
            }
          }
        }

        /* Hero Action Buttons */
        .hero-actions-row {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 12px;

          .non-member-link {
            text-decoration: none;
          }

          .glass-btn {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            padding: 10px 20px;
            border-radius: 12px;
            font-size: 13px;
            font-weight: 700;
            cursor: pointer;
            transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
            position: relative;
            overflow: hidden;

            .btn-icon,
            i {
              font-size: 16px;
              color: #ffffff !important;
            }

            &.primary-glass-btn {
              background: linear-gradient(135deg, #edbe38 0%, #d49b1f 100%);
              color: $jci-off-black;
              border: none;
              box-shadow: 0 6px 18px rgba(237, 190, 56, 0.35);

              .btn-icon,
              i {
                color: $jci-off-black !important;
              }

              &:hover {
                transform: translateY(-2px) scale(1.02);
                box-shadow: 0 10px 25px rgba(237, 190, 56, 0.5);
              }
            }

            &.secondary-glass-btn {
              background: rgba(255, 255, 255, 0.2);
              color: $jci-white;
              border: 1px solid rgba(255, 255, 255, 0.4);
              box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);

              &:hover {
                background: rgba(255, 255, 255, 0.35);
                color: $jci-white;
                border-color: #ffffff;
                transform: translateY(-2px) scale(1.02);
                box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
              }
            }
          }
        }
      }
    }
  }

  /* STATISTICS BAR */
  .luxury-stats-bar {
    margin-top: -30px;
    position: relative;
    z-index: 10;
    padding: 0 24px;

    .stats-container {
      max-width: 1140px;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
      gap: 16px;

      .stat-card {
        background: #ffffff;
        backdrop-filter: blur(20px);
        border: 2px solid #1565c0 !important;
        border-radius: 20px;
        padding: 20px;
        display: flex;
        align-items: center;
        gap: 16px;
        box-shadow: 0 10px 30px rgba(21, 101, 192, 0.15);
        transition: all 0.35s ease;

        &:hover {
          transform: translateY(-4px);
          border-color: $jci-aqua !important;
          box-shadow: 0 15px 35px rgba(0, 151, 215, 0.18);
        }

        .stat-icon-box {
          width: 50px;
          height: 50px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          background: linear-gradient(
            135deg,
            #1e3a8a 0%,
            #1565c0 100%
          ) !important;
          color: #ffffff !important;
          box-shadow: 0 4px 12px rgba(21, 101, 192, 0.25);

          i {
            color: #ffffff !important;
          }

          &.gold {
            background: linear-gradient(
              135deg,
              #edbe38 0%,
              #d49b1f 100%
            ) !important;
          }
          &.purple {
            background: linear-gradient(
              135deg,
              #1e3a8a 0%,
              #3a67b1 100%
            ) !important;
          }
          &.blue {
            background: linear-gradient(
              135deg,
              #1565c0 0%,
              #0097d7 100%
            ) !important;
          }
          &.emerald {
            background: linear-gradient(
              135deg,
              #56bda3 0%,
              #0f766e 100%
            ) !important;
          }
        }

        .stat-info {
          .stat-value {
            font-size: 18px;
            font-weight: 800;
            color: $jci-off-black;
            line-height: 1.2;
          }
          .stat-label {
            font-size: 12px;
            color: $jci-text-90black;
            margin-top: 2px;
          }
        }
      }
    }
  }

  // ============================================
  // FORM CARDS & TABLE
  // ============================================
  .form-card {
    border-radius: 18px !important;
    border: 1px solid rgba(21, 101, 192, 0.18) !important;
    box-shadow: 0 10px 30px rgba(21, 101, 192, 0.08) !important;
    background: #ffffff !important;

    .form-card-header {
      display: flex;
      align-items: center;
      padding: 16px 24px;
      border-radius: 16px 16px 0 0;
      background: linear-gradient(
        135deg,
        #1e3a8a 0%,
        #1565c0 50%,
        #0097d7 100%
      ) !important;
      color: #ffffff !important;

      .header-icon {
        color: #ffffff !important;
      }

      .form-card-title {
        color: #ffffff !important;
        font-size: 18px;
        font-weight: 800;
      }

      .form-card-subtitle {
        color: rgba(255, 255, 255, 0.85) !important;
        font-size: 12px;
      }
    }

    .qty-display {
      text-align: center;
      padding: 16px 24px;
      background: rgba(0, 151, 215, 0.07);
      border-radius: 14px;
      border: 1.5px solid rgba(0, 151, 215, 0.25);

      .qty-value {
        font-size: 36px !important;
        font-weight: 900 !important;
        color: #1565c0 !important;
        line-height: 1;
        margin-bottom: 4px;

        strong {
          font-weight: 900 !important;
        }
      }

      .qty-label {
        font-size: 12px;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 1px;
        color: #4a5568;
      }
    }
  }

  .table-wrapper {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 25px rgba(21, 101, 192, 0.1);

    .professional-table {
      .table-header-cell {
        background: linear-gradient(
          135deg,
          #1e3a8a 0%,
          #1565c0 100%
        ) !important;
        color: #ffffff !important;
        font-weight: 800;
        font-size: 12px;
        letter-spacing: 0.5px;
      }
    }
  }

  /* ==========================================================================
     PREMIUM PLAN CARDS SECTION
     ========================================================================== */
  .plans-section-header {
    text-align: center;
    margin: 60px 0 40px 0;

    .section-badge {
      display: inline-block;
      font-size: 11px;
      font-weight: 800;
      letter-spacing: 2.5px;
      color: $jci-navy;
      background: rgba(58, 103, 177, 0.12);
      padding: 6px 16px;
      border-radius: 100px;
      border: 1px solid rgba(58, 103, 177, 0.3);
      margin-bottom: 12px;
    }

    .section-title {
      font-size: clamp(26px, 3.5vw, 38px);
      font-weight: 900;
      color: $jci-off-black;
      letter-spacing: -0.5px;
    }

    .section-subtitle {
      font-size: 15px;
      color: $jci-text-90black;
      margin-top: 4px;
    }

    /* Existing Plan Luxury Card */
    .existing-plan-card-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 0 0 0;
    }

    .existing-plan-card {
      background: linear-gradient(
        135deg,
        rgba(255, 248, 225, 0.98) 0%,
        rgba(227, 242, 253, 0.98) 100%
      );
      border: 2px solid #ffb300;
      border-radius: 16px;
      padding: 16px 28px;
      box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
      max-width: 540px;
      width: 100%;
      text-align: center;
      margin: 0 auto;

      .existing-plan-card-header {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 10px;
      }

      .existing-plan-card-body {
        text-align: center;
      }

      .existing-plan-text {
        font-size: 16px;
        color: #1a237e;
        font-weight: 600;

        .existing-plan-name {
          font-size: 18px;
          font-weight: 900;
          color: #b78103;
          letter-spacing: 0.5px;
        }
      }
    }
  }

  .plans-grid-row {
    .plan-card-col {
      display: flex;
      justify-content: center;
    }

    .cards-box {
      margin-top: 10px;
      width: 100%;
      max-width: 320px;
    }

    /* Base Cards Redesign: Whole Card JCSAT Order Summary Header Blue Gradient */
    .cards.luxury-plan-card {
      position: relative;
      background: linear-gradient(
        135deg,
        #1e3a8a 0%,
        #1565c0 50%,
        #0097d7 100%
      ) !important;
      background-size: 400% 400% !important;
      animation: gradientShift 15s ease infinite,
        planCardBreathing 8s ease-in-out infinite alternate !important;
      backdrop-filter: blur(24px);
      -webkit-backdrop-filter: blur(24px);
      border: 1.5px solid rgba(255, 255, 255, 0.3) !important;
      border-radius: 28px !important;
      padding: 32px 24px 28px 24px !important;
      width: 100% !important;
      min-height: 440px;
      height: auto !important;
      margin: 0 !important;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      color: #ffffff !important;
      box-shadow: 0 20px 50px rgba(21, 101, 192, 0.25) !important;
      transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
      overflow: hidden;

      &:hover {
        transform: translateY(-10px) scale(1.02);
        box-shadow: 0 30px 65px rgba(0, 151, 215, 0.35) !important;
        border-color: #ffd54f !important;
      }

      /* Silvery Metallic Sheen Effect */
      .silvery-shine-sweep {
        position: absolute;
        top: -50%;
        left: -150%;
        width: 100%;
        height: 200%;
        background: linear-gradient(
          105deg,
          transparent 0%,
          rgba(255, 255, 255, 0) 30%,
          rgba(255, 255, 255, 0.45) 45%,
          rgba(240, 248, 255, 0.95) 50%,
          rgba(255, 255, 255, 0.45) 55%,
          rgba(255, 255, 255, 0) 70%,
          transparent 100%
        );
        transform: rotate(25deg);
        animation: silverShineSweep 6s infinite ease-in-out;
        pointer-events: none;
        z-index: 5;
      }

      .card-shimmer-sweep {
        position: absolute;
        top: 0;
        left: -150%;
        width: 80%;
        height: 100%;
        background: linear-gradient(
          90deg,
          transparent,
          rgba(255, 255, 255, 0.35),
          transparent
        );
        transform: skewX(-25deg);
        animation: shineSweep 7s infinite ease-in-out;
        pointer-events: none;
      }

      /* Mild Inner Card Ambient Aura Glow */
      .card-glow-aura {
        position: absolute;
        top: -30%;
        right: -30%;
        width: 200px;
        height: 200px;
        background: radial-gradient(
          circle,
          rgba(255, 255, 255, 0.25) 0%,
          rgba(0, 151, 215, 0.15) 50%,
          transparent 75%
        );
        pointer-events: none;
        animation: pulseGlow 4s infinite alternate ease-in-out;
      }

      /* Unified Card Title & Subtitle Alignment */
      .cards-title-bar {
        background: none !important;
        padding: 0;
        margin-bottom: 16px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;

        .cards-title {
          font-size: 24px !important;
          font-weight: 900;
          color: #ffffff !important;
          text-transform: none !important;
          letter-spacing: -0.5px;
          margin: 0;
          text-align: center;
          width: 100%;
          text-shadow: 0 3px 12px rgba(0, 0, 0, 0.3);

          &.gold-title {
            color: #ffd54f !important;
            text-shadow: 0 3px 12px rgba(0, 0, 0, 0.4);
          }

          &.emerald-title {
            color: #ffffff !important;
          }
        }

        .cards-subtitle {
          font-size: 13px !important;
          color: rgba(255, 255, 255, 0.95) !important;
          margin-top: 6px;
          font-weight: 500;
          line-height: 1.4;
          text-align: center;
          width: 100%;
        }

        .upgrade-info-card {
          width: 100%;
          background: rgba(10, 15, 41, 0.35);
          backdrop-filter: blur(12px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 18px;
          padding: 14px 16px;
          margin-top: 12px;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2),
            inset 0 1px 0 rgba(255, 255, 255, 0.2);

          .upgrade-badge-header {
            text-align: center;
            margin-bottom: 10px;

            .upgrade-pill {
              font-size: 11px !important;
              font-weight: 800 !important;
              letter-spacing: 0.5px;
              padding: 4px 12px;
            }
          }

          .existing-plan-banner {
            background: rgba(255, 255, 255, 0.15);
            border-radius: 12px;
            padding: 8px 12px;
            margin-bottom: 10px;
            text-align: center;
            border: 1px solid rgba(255, 255, 255, 0.25);

            .existing-label {
              display: block;
              font-size: 10px;
              font-weight: 800;
              text-transform: uppercase;
              letter-spacing: 1px;
              color: #ffd54f;
              margin-bottom: 2px;
            }

            .existing-name-full {
              font-size: 13px;
              font-weight: 800;
              color: #ffffff;
              line-height: 1.35;
              word-break: break-word;
            }
          }

          .upgrade-details-list {
            display: flex;
            flex-direction: column;
            gap: 8px;

            .upgrade-detail-row {
              display: flex;
              align-items: center;
              justify-content: space-between;
              gap: 8px;
              font-size: 13px;
              line-height: 1.3;

              .detail-label {
                font-weight: 600;
                color: rgba(255, 255, 255, 0.85);
                font-size: 13px;
              }

              .detail-value {
                font-weight: 800;
                color: #ffffff;
                font-size: 14px;
                text-align: right;

                &.highlight-gold {
                  color: #ffd54f !important;
                  font-weight: 900;
                  font-size: 15px;
                }

                &.highlight-emerald {
                  color: #56bda3 !important;
                  font-weight: 900;
                  font-size: 14px;
                }
              }
            }
          }
        }
      }

      /* Popular / Recommended Card Accent */
      &.recommended-card {
        border: 2px solid $jci-gold !important;
        box-shadow: 0 20px 50px rgba(237, 190, 56, 0.25) !important;
      }

      /* Upgrade Plan Card Accent */
      &.emerald-upgrade-card {
        border: 2px solid #56bda3 !important;
      }

      /* Pricing Area Alignment */
      .cards-price {
        margin: 16px 0 !important;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;

        .upgrade-pending-txt {
          color: #ffd54f !important;
          text-align: center;
          width: 100%;
          font-size: 13px;
          font-weight: 800;
        }

        .cards-price-amount {
          font-size: 34px !important;
          font-weight: 900;
          color: #ffffff !important;
          text-align: center;
          width: 100%;
          text-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);

          .cards-price-validity {
            display: block;
            font-size: 11px !important;
            letter-spacing: 1.5px;
            color: rgba(255, 255, 255, 0.85) !important;
            margin-top: 4px;
            text-align: center;
            width: 100%;
          }

          .cards-price-gst {
            display: block;
            font-size: 13px !important;
            color: #ffd54f !important;
            font-weight: 800;
            text-align: center;
            width: 100%;
          }
        }

        .show-details-btn {
          font-size: 11px !important;
          font-weight: 700;
          letter-spacing: 0.5px;
          text-transform: none;
          color: #ffffff !important;
          border-color: rgba(255, 255, 255, 0.6) !important;
          background: rgba(255, 255, 255, 0.15) !important;
          margin: 10px auto 0 auto;
          transition: all 0.3s ease;

          i {
            color: #ffffff !important;
          }

          &:hover {
            background: rgba(255, 255, 255, 0.3) !important;
            border-color: #ffffff !important;
            transform: translateY(-2px);
          }
        }
      }

      /* Total Section Alignment */
      .cards-total-box {
        margin-top: 16px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;

        .total-divider {
          height: 1px;
          width: 80%;
          margin: 0 auto 12px auto;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.4),
            transparent
          );
        }

        .total-amount-single-line {
          display: flex;
          align-items: center;
          justify-content: space-between;
          white-space: nowrap;
          width: 100%;
          padding: 4px 8px;

          .total-amount-label {
            font-size: 13px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            color: rgba(255, 255, 255, 0.9);
          }

          .total-amount-value {
            font-size: 22px;
            font-weight: 900;
            color: #ffd54f;
            text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
            white-space: nowrap;
          }
        }

        .total-amount-display {
          font-size: 28px !important;
          font-weight: 900;
          color: #ffd54f !important;
          text-align: center;
          width: 100%;
          text-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
        }
      }

      /* Action Pay Buttons Alignment */
      .cards-action {
        width: 100%;
        margin-top: 16px;
        display: flex;
        justify-content: center;
        align-items: center;

        .cards-action-button {
          width: 100%;
          height: 52px !important;
          border-radius: 16px !important;
          font-size: 14px !important;
          font-weight: 800 !important;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          cursor: pointer;
          transition: all 0.35s ease;
          position: relative;
          overflow: hidden;
          background: linear-gradient(
            135deg,
            #edbe38 0%,
            #d49b1f 100%
          ) !important;
          color: $jci-off-black !important;
          border: none !important;
          box-shadow: 0 10px 25px rgba(237, 190, 56, 0.4);

          .btn-arrow,
          i {
            color: $jci-off-black !important;
          }

          &:hover:not(:disabled) {
            transform: translateY(-2px);
            box-shadow: 0 15px 35px rgba(237, 190, 56, 0.6);
          }

          &.emerald-action-btn {
            background: linear-gradient(
              135deg,
              #56bda3 0%,
              #0f766e 100%
            ) !important;
            color: #ffffff !important;
            box-shadow: 0 10px 25px rgba(86, 189, 163, 0.4);

            .btn-arrow,
            i {
              color: #ffffff !important;
            }
          }
        }
      }
    }

    /* RECOMMENDED CARD SPECIFIC STYLING */
    .recommended-card {
      border: 2px solid $jci-gold !important;
      box-shadow: 0 20px 50px rgba(237, 190, 56, 0.35) !important;

      .card-glow-aura {
        position: absolute;
        inset: -2px;
        border-radius: 30px;
        background: radial-gradient(
          circle at 50% 0%,
          rgba(237, 190, 56, 0.15) 0%,
          transparent 60%
        );
        pointer-events: none;
      }

      /* 3D Folded Metallic Gold Ribbon */
      .luxury-3d-ribbon {
        position: absolute;
        top: 18px;
        right: -32px;
        width: 140px;
        background: linear-gradient(
          135deg,
          #edbe38 0%,
          #fff3b0 30%,
          #d49b1f 70%,
          #edbe38 100%
        );
        transform: rotate(45deg);
        padding: 6px 0;
        text-align: center;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
        z-index: 10;
        overflow: hidden;

        span {
          font-size: 10px;
          font-weight: 900;
          letter-spacing: 1px;
          color: $jci-off-black;
          text-transform: uppercase;
          display: block;
        }

        .ribbon-shine {
          position: absolute;
          top: 0;
          left: -100%;
          width: 50%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.6),
            transparent
          );
          transform: skewX(-20deg);
          animation: shineSweep 4s infinite;
        }
      }
    }
  }
}

// Keyframe Animations
@keyframes meshMovement {
  0% {
    transform: scale(1) translate(0, 0);
  }
  50% {
    transform: scale(1.1) translate(-2%, 2%);
  }
  100% {
    transform: scale(1) translate(2%, -2%);
  }
}

@keyframes auroraShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes floatOrb {
  0% {
    transform: translateY(0px) scale(1);
  }
  100% {
    transform: translateY(-30px) scale(1.08);
  }
}

@keyframes rotateRays {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes floatSlow {
  0% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-15px) rotate(5deg);
  }
  100% {
    transform: translateY(0) rotate(0deg);
  }
}

@keyframes pulseGlow {
  0% {
    opacity: 0.4;
    transform: scale(0.98);
  }
  100% {
    opacity: 1;
    transform: scale(1.05);
  }
}

@keyframes heroCardBreathing {
  0% {
    transform: translateY(0);
    box-shadow: 0 20px 60px rgba(58, 103, 177, 0.12);
  }
  100% {
    transform: translateY(-6px);
    box-shadow: 0 30px 70px rgba(58, 103, 177, 0.18);
  }
}

@keyframes silverShineSweep {
  0% {
    left: -150%;
  }
  25% {
    left: 150%;
  }
  100% {
    left: 150%;
  }
}

@keyframes shineSweep {
  0% {
    left: -150%;
  }
  30% {
    left: 150%;
  }
  100% {
    left: 150%;
  }
}

@keyframes pulseText {
  0%,
  100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes floatUp3DBubble {
  0% {
    transform: translateY(0) scale(0.7) rotate(0deg);
    opacity: 0;
  }
  15% {
    opacity: 0.95;
  }
  85% {
    opacity: 0.95;
  }
  100% {
    transform: translateY(-280px) scale(1.25) rotate(360deg);
    opacity: 0;
  }
}
</style>
